import PropTypes from 'prop-types'

const child = PropTypes.oneOfType([PropTypes.node, PropTypes.string])

export default {
  child,
  children: PropTypes.oneOfType([PropTypes.arrayOf(child), child]),
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.object,
  ]),
}
